const fetchEquipmentUseCase = (repository) => async (pagination, search, status, includeIDs) => {
    const payload = {
        sort: pagination.sortBy.map((s) => [s]).join(','),
        descending: pagination.sortDesc.join(','),
        page: pagination.page,
        itemsPerPage: pagination.itemsPerPage,
        search: search,
        status: status,
        includeIDs: includeIDs,
    }
    return await repository(payload);
}

export default fetchEquipmentUseCase;